var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlusBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.45945 10.5314H5.29279C5.13959 10.5314 5.01112 10.4799 4.90737 10.377C4.80376 10.2741 4.75195 10.1452 4.75195 9.99031C4.75195 9.83559 4.80376 9.70677 4.90737 9.60385C5.01112 9.50108 5.13959 9.44969 5.29279 9.44969H9.45945V5.28302C9.45945 5.12983 9.51147 5.00135 9.61549 4.8976C9.71952 4.79399 9.84834 4.74219 10.002 4.74219C10.1557 4.74219 10.284 4.79399 10.387 4.8976C10.4897 5.00135 10.5411 5.12983 10.5411 5.28302V9.44969H14.7078C14.861 9.44969 14.9895 9.5017 15.0932 9.60573C15.1968 9.70976 15.2486 9.83872 15.2486 9.9926C15.2486 10.1489 15.1968 10.2777 15.0932 10.3791C14.9895 10.4806 14.861 10.5314 14.7078 10.5314H10.5411V14.698C10.5411 14.8536 10.4891 14.9826 10.3851 15.0851C10.2811 15.1876 10.1522 15.2389 9.99862 15.2389C9.84487 15.2389 9.71654 15.1876 9.61362 15.0851C9.51084 14.9826 9.45945 14.8536 9.45945 14.698V10.5314Z",
    fill: "#0064E0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusBlue);
export default __webpack_public_path__ + "static/media/PlusBlue.9872c6d6ff2e85ea4cc99754eb5516ca.svg";
export { ForwardRef as ReactComponent };